export default __webpack_public_path__ + "scene5_2_icon766636.png";